/** Valores alinhados ao backend (PlanoContingenciaStatus). Original: 0, 1, 2; novos sequenciais: 3, 4, 5, 6. */
export enum PlanoStatus {
  Pendente = 0,
  Aprovado = 1,
  Reprovado = 2,
  Novo = 3,
  /** Aguardando validação Supervisor de Ensino */
  AguardandoValidacaoSupervisor = 4,
  /** Aguardando validação PEC CONVIVA */
  AguardandoValidacaoPecConviva = 5,
  /** Devolvido para ajustes */
  DevolvidoAjustes = 6
}
